import { FacebookIcon, GoogleIcon } from '@theprintbar/ui';
import { SocialsProvider } from 'remix-auth-socials';
import { SocialButton } from './SocialButton';

interface SingleSignOnProps {
	callback?: string | null;
	hr?: string;
}

export function SingleSignOn({ callback, hr }: SingleSignOnProps) {
	return (
		<div className="grid grid-cols-2 gap-4">
			<SocialButton
				callback={callback}
				provider={SocialsProvider.FACEBOOK}
				icon={({ className }) => <FacebookIcon className={className} />}
				className="bg-[#1877F2] w-full max-h-8 text-white"
			>
				Sign In with Facebook
			</SocialButton>
			<SocialButton
				callback={callback}
				provider={SocialsProvider.GOOGLE}
				icon={GoogleIcon}
				className="bg-white w-full max-h-8 text-black shadow"
			>
				Sign In with Google
			</SocialButton>
		</div>
	);
}
